import React from "react";
import "./banner.less";
import { Invit } from "../../../../types/invit.types";

interface BannerProps {
  invitData: Invit;
}

const Banner: React.FC<BannerProps> = ({ invitData }) => {
  if (!invitData) return null;

  // ✅ Latest Financial Data
  const latestFinancial = invitData.financialMetrics?.slice(-1)[0];
  const latestQuarter = latestFinancial?.quarters?.slice(-1)[0];

  // ✅ Latest Operational Data
  const latestOperational = invitData.operationalMetrics?.slice(-1)[0] as any;
  const latestSemiAnnual = latestOperational?.semiAnnuals?.slice(-1)[0];

  const sectorOfOperation = latestSemiAnnual?.sectorOfOperation?.name || "N/A";

  const listingDates: Record<string, string> = {
    "IRB InvIT Fund": "18 May 2017",
    "Indus Infra Trust": "12 March 2024",
    "PowerGrid InvIT": "14 May 2021",
    "IndiGrid InvIT": "6 June 2017",
    "Capital Infra Trust": "17 January 2025",
  };

  const listingDate = listingDates[invitData.name] || "N/A";

  const isPublicInvit = listingDates.hasOwnProperty(invitData.name);

  return (
    <section className="hero">
      <div className="hero__back"></div>

      <div className="hero__body">
        {/* ✅ Left Image (commented out for now)
        <div className="hero__pic">
          <img src={fallbackImage} alt={invitData.name} />
        </div>
        */}

        <div className="hero__content">
          <div className="hero__head">
            <div className="hero__head-information">
              <h2 className="hero__heading">{invitData.name}</h2>
              <p className="hero__info">
                Industry: <strong>{sectorOfOperation}</strong>
              </p>

              {isPublicInvit && (
                <p className="hero__info">
                  Listing Date: <strong>{listingDate}</strong>
                </p>
              )}

              {latestQuarter?.marketCapitalisation?.value && (
                <p className="hero__info">
                  Market Cap:{" "}
                  <strong>{latestQuarter.marketCapitalisation.value}</strong>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
